"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHandler = void 0;
const router_1 = require("@keplr-wallet/router");
const messages_1 = require("./messages");
const getHandler = (service) => {
    return (env, msg) => {
        switch (msg.constructor) {
            case messages_1.GetPubkeyMsg:
                return handleGetPubkeyMsg(service)(env, msg);
            case messages_1.ReqeustEncryptMsg:
                return handleReqeustEncryptMsg(service)(env, msg);
            case messages_1.RequestDecryptMsg:
                return handleRequestDecryptMsg(service)(env, msg);
            case messages_1.GetTxEncryptionKeyMsg:
                return handleGetTxEncryptionKeyMsg(service)(env, msg);
            default:
                throw new router_1.KeplrError("secret-wasm", 120, "Unknown msg type");
        }
    };
};
exports.getHandler = getHandler;
const handleGetPubkeyMsg = (service) => {
    return (env, msg) => __awaiter(void 0, void 0, void 0, function* () {
        yield service.permissionService.checkOrGrantBasicAccessPermission(env, msg.chainId, msg.origin);
        return yield service.getPubkey(env, msg.chainId);
    });
};
const handleReqeustEncryptMsg = (service) => {
    return (env, msg) => __awaiter(void 0, void 0, void 0, function* () {
        yield service.permissionService.checkOrGrantBasicAccessPermission(env, msg.chainId, msg.origin);
        // TODO: Should ask for user whether approve or reject to encrypt.
        return yield service.encrypt(env, msg.chainId, msg.contractCodeHash, msg.msg);
    });
};
const handleRequestDecryptMsg = (service) => {
    return (env, msg) => __awaiter(void 0, void 0, void 0, function* () {
        yield service.permissionService.checkOrGrantBasicAccessPermission(env, msg.chainId, msg.origin);
        // XXX: Is there need to ask for user whether approve or reject to decrypt?
        return yield service.decrypt(env, msg.chainId, msg.cipherText, msg.nonce);
    });
};
const handleGetTxEncryptionKeyMsg = (service) => {
    return (env, msg) => __awaiter(void 0, void 0, void 0, function* () {
        yield service.permissionService.checkOrGrantBasicAccessPermission(env, msg.chainId, msg.origin);
        // XXX: Is there need to ask for user whether approve or reject to getting tx encryption key?
        return yield service.getTxEncryptionKey(env, msg.chainId, msg.nonce);
    });
};
//# sourceMappingURL=handler.js.map